<template>
  <div class="page content-display">
    <div class="page__head">
      <page-header :title="title" :back-location="localePath({ name: 'index' })">
        <template #title>
          <slot name="title" />
        </template>
      </page-header>
    </div>
    <div class="page__main page__main--fill">
      <div class="layout layout--primary">
        <div class="layout__container">
          <div class="grid grid--primary">
            <div class="content-display__main">
              <slot name="default" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="page__foot">
      <footer-navigation />
    </div>
  </div>
</template>

<script>
  import PageHeader from '@/components/page-header/page-header'
  import FooterNavigation from '@/components/footer-navigation/footer-navigation'

  export default {
    components: { FooterNavigation, PageHeader },
    props: {
      title: {
        type: String,
        default: null,
      },
    },
  }
</script>

<style lang="scss" src="./_content-display.scss" />
